import { render, staticRenderFns } from "./VBreadcrumbs.vue?vue&type=template&id=e76e1e0e&"
import script from "./VBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./VBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports